import React from 'react'
import * as reactstrap from 'reactstrap'
const { Row: RSRow } = reactstrap

export const Row = ({ hide = false, show = true, children, ...rest }) => {
  if (hide === true) {
    return null
  }

  if (show === false) {
    return null
  }

  return <RSRow {...rest}>{children}</RSRow>
}
